import { BulkPropertyForm } from "apps/batchOnboarding/BulkPropertyForm";
import { useGetBulkOnboardingDataApi } from "apps/batchOnboarding/useGetBulkOnboardingDataApi";
import { OnboardingGrid } from "apps/commons/components/OnboardingGrid";
import { OneOnboardingSkeleton } from "apps/oneOnboarding/Skeleton";
import { Notifications } from "apps/oneOnboarding/notification/Notifications";
import { Sidebar } from "apps/oneOnboarding/sidebar";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";

const Layout = () => {
    const staticData = useStaticDataAtomValue();
    const { data, metadata, isLoading, refetch: refetchBulkOnboardingData } = useGetBulkOnboardingDataApi();

    const location = useLocation();

    const handleRefetch = () => {
        refetchBulkOnboardingData();
    };

    useEffect(() => {
        if (location.state && location.state.shouldRefetch) {
            handleRefetch();
            // Clean up state to prevent refetching on future renders
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    const shouldShowSkeleton = staticData === undefined || data === undefined || metadata === undefined || isLoading;

    return (
        <>
            <OnboardingGrid
                sidebar={<Sidebar />}
                content={
                    shouldShowSkeleton ? (
                        <OneOnboardingSkeleton />
                    ) : (
                        <BulkPropertyForm
                            data={{
                                propertyDataList: data.propertyDataList,
                            }}
                        >
                            <Outlet />
                        </BulkPropertyForm>
                    )
                }
            />
            {staticData !== undefined && <Notifications />}
        </>
    );
};

export default Layout;
